<!-- 企业微信设置 -->
<template>
  <div class="agent-set">
    <el-form
      ref="form"
      v-loading="loading"
      :model="agentForm"
      :rules="rules"
      label-width="140px"
      label-position="left"
    >
      <!--  -->
      <el-form-item label="企业ID" prop="corpid">
        <div class="line-box">
          <div class="line-item" v-if="!one">
            <p class="line-one">{{ agentForm.corpid }}</p>
            <el-button class="line-two" type="text" @click="hanldeEdit('one')">修改</el-button>
          </div>
          <div class="line-item" v-else>
            <el-input
              ref="one"
              class="line-one"
              v-model.trim="agentForm.corpid"
              @blur="(event) => hanldeBlur(event, 'one')"
            ></el-input>
          </div>
          <p class="tip" @click="() => getTip(g_imgSrc.agentSet.one)">如何获取</p>
        </div>
      </el-form-item>
      <!--  -->
      <el-form-item label="通讯录Secret" prop="contactSecret">
        <div class="line-box">
          <div class="line-item" v-if="!two">
            <p class="line-one">{{ agentForm.contactSecret }}</p>
            <el-button class="line-two" type="text" @click="hanldeEdit('two')">修改</el-button>
          </div>
          <div class="line-item" v-else>
            <el-input
              ref="two"
              class="line-one"
              v-model.trim="agentForm.contactSecret"
              @blur="(event) => hanldeBlur(event, 'two')"
            ></el-input>
          </div>
          <p class="tip" @click="() => getTip(g_imgSrc.agentSet.two)">如何获取</p>
        </div>
      </el-form-item>
      <!--  -->
      <el-form-item label="客户联系Secret" prop="customerSecret">
        <div class="line-box">
          <div class="line-item" v-if="!three">
            <p class="line-one">{{ agentForm.customerSecret }}</p>
            <el-button class="line-two" type="text" @click="hanldeEdit('three')">修改</el-button>
          </div>
          <div class="line-item" v-else>
            <el-input
              ref="three"
              class="line-one"
              v-model.trim="agentForm.customerSecret"
              @blur="(event) => hanldeBlur(event, 'three')"
            ></el-input>
          </div>
          <p class="tip" @click="() => getTip(g_imgSrc.agentSet.three)">如何获取</p>
        </div>
      </el-form-item>
      <!--  -->
      <el-form-item label="会话留存secret" prop="chatSecret">
        <div class="line-box">
          <div class="line-item" v-if="!four">
            <p class="line-one">{{ agentForm.chatSecret }}</p>
            <el-button class="line-two" type="text" @click="hanldeEdit('four')">修改</el-button>
          </div>
          <div class="line-item" v-else>
            <el-input
              ref="four"
              class="line-one"
              v-model.trim="agentForm.chatSecret"
              @blur="(event) => hanldeBlur(event, 'four')"
            ></el-input>
          </div>
          <p class="tip" @click="() => getTip(g_imgSrc.agentSet.four)">如何获取</p>
        </div>
      </el-form-item>

      <el-form-item class="submit" label-width="0">
        <el-button type="primary" @click="() => onSubmit()">保存</el-button>
      </el-form-item>
    </el-form>
    <!-- 如何获取de弹窗 -->
    <ImgDialog :dialog-visible.sync="dialog.visible" :src="dialog.src"></ImgDialog>
  </div>
</template>
<script>
import ImgDialog from './component/img-dialog';
import { getAgentManagementApi, updateAgentManagementApi } from '@/api/setUser';

export default {
  name: 'AgentSet',
  components: { ImgDialog },
  data() {
    return {
      loading: false,
      agentForm: {
        corpid: '',
        contactSecret: '',
        customerSecret: '',
        chatSecret: '',
      },
      rules: {
        corpid: [{ required: true, message: '请输入', trigger: 'blur' }],
        contactSecret: [{ required: true, message: '请输入', trigger: 'blur' }],
        customerSecret: [{ required: true, message: '请输入', trigger: 'blur' }],
        chatSecret: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      one: false,
      two: false,
      three: false,
      four: false,
      dialog: {
        visible: false,
        src: '',
      } /* 弹窗 */,
    };
  },
  watch: {
    // [优化]可关闭 当弹窗关闭清空弹窗内的图片地址(否则二次打开其他弹窗会初始显示之前出现的src)
    'dialog.visible'(val) {
      if (!val) {
        this.dialog.src = '';
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    async init() {
      this.loading = true;
      try {
        const { config_map } = await getAgentManagementApi();
        const agentForm = {
          corpid: config_map.corpid || '',
          contactSecret: config_map.contactSecret || '',
          customerSecret: config_map.customerSecret || '',
          chatSecret: config_map.chatSecret || '',
        };
        this.agentForm = agentForm;
        // base64解密
        // this.agentForm = this.base64Deciphering(agentForm);
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },
    /** 启动编辑
     * @description 点击修改按钮, 切换html显示状态并自动聚焦input输入框
     * @param {String} params 参数  按照html排序one/two/three...递增
     * @return {*}
     */
    hanldeEdit(params) {
      this[params] = true;
      this.$nextTick(() => {
        // 自动获取焦点
        this.$refs[params].$refs.input.focus();
      });
    },
    /** 失去焦点
     * @description 通过原生event判断是否输入为空, 空则不让失去焦点
     * @param {Object} event
     * @param {String} params 参数  按照html排序one/two/three...递增
     * @return {*}
     */
    hanldeBlur(event, params) {
      if (event.target.value) {
        this[params] = false;
      }
    },
    // 如何获取
    getTip(e) {
      this.dialog = {
        visible: true,
        src: e,
      };
    },
    // 提交验证
    onSubmit(formName = 'form') {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateFun();
        }
      });
    },
    // 更新接口
    async updateFun() {
      this.loading = true;
      const { agentForm } = this;
      // base64加密
      //   const agentForm = this.base64Encryption(this.agentForm);
      try {
        await updateAgentManagementApi({
          config_map: { ...agentForm },
        });
        this.$message.success('保存成功');
      } catch (error) {
        this.$message.error(error.message);
      }
      this.loading = false;
    },

    // base64加密
    base64Encryption(obj) {
      const temp = { ...obj };
      for (const [key, val] of Object.entries(temp)) {
        temp[key] = window.btoa(window.encodeURIComponent(val));
      }
      return temp;
    },
    // base64解密
    base64Deciphering(obj) {
      const temp = { ...obj };
      for (const [key, val] of Object.entries(temp)) {
        temp[key] = window.decodeURIComponent(window.atob(val));
      }
      return temp;
    },
  },
};
</script>
<style lang="scss" scoped>
.agent-set {
  width: 70%;
  margin-top: 48px;

  // input行
  .line-box {
    display: flex;
    .line-item {
      .line-one {
        width: 500px;
        display: inline-block;
        word-break: break-all;
      }
      .line-two {
        margin-left: 10px;
      }
    }
  }

  // 如何获取
  .tip {
    display: inline-block;
    padding-left: 10px;
    color: #2f96ff;
    cursor: pointer;
    &:hover {
      color: #6eb6fd;
    }
  }

  // 提交
  .submit {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    button {
      width: 216px;
      height: 48px;
      font-size: 16px;
    }
  }
}
</style>
